<template>
  <aha-modal
    :title="$i18nPresenter.t('Access Request')"
    @hide="$emit('cancel')"
    :height="500"
  >
    <div class="mb-4">
      <p class="text-base">
        {{ $i18nPresenter.t('Do you allow this app to access your profile?') }}
      </p>
    </div>

    <template #action>
      <div class="flex justify-end gap-2">
        <aha-link
          v-aha-emit-action
          name="cancel-third-party-access"
          @click="$emit('cancel')"
        >
          {{ $i18nPresenter.t('Cancel') }}
        </aha-link>

        <aha-button
          v-aha-emit-action
          name="confirm-third-party-access"
          @click="$emit('confirm')"
        >
          {{ $i18nPresenter.t('Allow') }}
        </aha-button>
      </div>
    </template>
  </aha-modal>
</template>

<script>
export default {
  name: 'ProfileAccessConfirm',
  emits: ['confirm', 'cancel'],
}
</script>
